import 'client-only';
import { logger } from '@curology/logger/client';
import { getCookieOptions, validateCookie } from '@curology/site-tools';
// @ts-expect-error - TODO: broken by noImplicitAny
import Cookies, { type CookieAttributes } from 'js-cookie';

import { type CookieKeyType } from '@/consts/cookieKeys';

const get = (key: CookieKeyType): string | undefined => Cookies.get(key);

const set = (
  key: CookieKeyType,
  value: string | string[],
  options: CookieAttributes = {},
): void => {
  const cookieValidation = validateCookie(key, value);
  if (!cookieValidation.ok) {
    logger.error(cookieValidation.message);
  }
  Cookies.set(key, value, getCookieOptions(options));
};

const remove = (key: CookieKeyType): void => {
  Cookies.remove(key, getCookieOptions());
};

const has = (key: CookieKeyType): boolean => !!get(key);

const cookieStorage = {
  get,
  has,
  remove,
  set,
};

export default cookieStorage;
